<template>
  <Drawer title="客户接入ERP/易流" width="1024"  :closable="false" v-model="_value">

    <Skeleton animated>
      <List item-layout="vertical">
        <ListItem v-for="item in data" :key="item.title">
          <ListItemMeta :title="item.title"/>
          {{ item.description }}<br/>
          {{ item.content }}<br/>
          {{ item.dispose }}
          <Button v-if="item.EXCELSrc" type="primary" size="small" @click="downloadTemple(item.EXCELSrc)" style="margin: 10px;">下载对接文档模板</Button>
          <Button v-if="item.pdfSrc" type="primary" size="small" @click="openpdf(item.pdfSrc)" style="margin: 10px;">详细文档</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <Button v-if="item.SIMSrc" type="primary" size="small" @click="openpdf(item.SIMSrc)" style="margin: 10px;">SIM卡白名单</Button>
          <iframe-modal v-model="Iframemodal" :initValue="IframeId"></iframe-modal>
          <template #extra>
            <img :src="item.imgSrc" style="width: 580px">
          </template>
        </ListItem>
      </List>
    </Skeleton>

  </Drawer>
</template>

<script>

/**
   * 引入自建组件/框架组件等位置
   */
import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'

import IframeModal from '@/view/om/technicalassistance/components/iframe-modal'

export default {
  name: 'erpexchangeaccessmodal',
  /**
     * 与组件引入的组件名一致，使用该组件
     * 下面是引入自建组件例子
     */
  components: {
    IframeModal
  },
  /**
     * 作为组件对应传送字段
     */
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    },

    Iframemodal: false,
    IframeId: null
  },
  /**
     * 默认数据/字段名创建
     */
  data () {
    return {
      /**
         * 下面是引入自建组件例子
         */
      maintainOrderAddMaintainDeviceRecordModal: false,
      maintainOrderAddMaintainDeviceRecordId: false,

      data: [
        {
          title: '客户接入ERP/易流',
          description: '1、按文档填写资料，设备添加/转发对应IP：112.74.160.123:2010，查询ERP：808是否有数据',
          content: '2、使用易流主动安全报警，发送文档至技术部工作人员',
          // dispose: '3、直连对接，下载对接文档填写资料，查询对应设备类型对接文档',
          EXCELSrc: '/ERP/ERP-ExchangeAccess-Modal.xlsx',
          imgSrc: '/ERP/ERP-ExchangeAccess-Modal.png'
          // pdfSrc: "/HIK/HIK-ExchangePlatform.pdf",
          // SIMSrc: "/SIM卡/WhiteList.pdf",
        }
      ]
    }
  },
  /**
   * 方法存储位置
   */
  methods: {
    ...mapActions([
      'VehicleInfoServ_SearchByName'
    ]),
    openpdf (e) {
      this.Iframemodal = true
      this.IframeId = e
    },
    downloadTemple (e) {
      console.log(e)
      window.location.href = e
    }
  },
  /** 作为组件的数值传输字段
     */
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  /**
   * 页面加载执行的代码
   * 可调用方法存储位置中的方法
   */
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>

<!--样式库-->
<style scoped>

</style>
